import Service from "@/services/container";
//import {router} from '@/plugins/router'

export default {
  namespaced: false,
  state: {
    list: {},
  },
  actions: {
    getContainer({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        Service.getOne(id)
          .then((data) => {
            resolve(data.data);
          })
          .catch((err) => {
            reject({});
            dispatch("alert/error", err, { root: true });
          });
      });
    },
    postContainer({ dispatch }, payload) {
      Service.post(payload.id, payload.param)
        .then(() => {
          //dispatch("alert/success", "Le document a été envoyé");
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
  },
  mutations: {},
};
